import React, { useEffect, useState } from "react";

// Hook to fetch server statuses
function useServerStatus() {
  const [minecraft, setMinecraft] = useState({ online: false, players: 0, max: 0, version: "", motd: "" });
  const [fivem, setFiveM] = useState({ online: false, players: 0, max: 0 });

  useEffect(() => {
    const minecraftIP = "latest-theta.gl.joinmc.link";
    const fivemIP = "9paq6e";

    // === Minecraft ===
    const fetchMinecraft = async () => {
      try {
        const res = await fetch(`https://api.mcsrvstat.us/2/${minecraftIP}`);
        const data = await res.json();
        setMinecraft({
          online: data.online,
          players: data.players?.online || 0,
          max: data.players?.max || 0,
          version: data.version || "",
          motd: data.motd?.clean?.join(" ") || "",
        });
      } catch {
        setMinecraft({ online: false, players: 0, max: 0, version: "", motd: "" });
      }
    };

    // === FiveM ===
    const fetchFiveM = async () => {
      try {
        // Replace with your actual FiveM server endpoint that returns JSON
        const res = await fetch(`https://api.yourfivemserver.com/status/${fivemIP}`);
        const data = await res.json();
        setFiveM({
          online: true,
          players: data.Data?.clients || 0,
          max: data.Data?.sv_maxclients || 0,
        });
      } catch {
        setFiveM({ online: false, players: 0, max: 0 });
      }
    };

    // Initial fetch
    fetchMinecraft();
    fetchFiveM();

    // Refresh every 15s
    const interval = setInterval(() => {
      fetchMinecraft();
      fetchFiveM();
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  return { minecraft, fivem };
}

function Games() {
  const { fivem } = useServerStatus();

  const minecraftIP = "latest-theta.gl.joinmc.link";
  const fivemIP = "9paq6e";

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert(`Copied ${text} to clipboard!`);
  };

  return (
    <div className="page-container" style={{ padding: "2rem", textAlign: "center" }}>
      <h1>Our Servers</h1>
      <p>
        Check out the amazing game servers we offer! From action-packed adventures to relaxing
        experiences, <strong>Vortex Network</strong> has something for everyone.
      </p>

      <ul className="server-list" style={{ listStyle: "none", padding: 0 }}>
        {/* === MINECRAFT === */}
        <li style={{ marginBottom: "2rem" }}>
          <h3>Minecraft Bedrock / Java Server</h3>
          <p>Join our world and explore custom prisons, survival realms, and more!</p>
          <a href="https://minecraftservers.org/server/685541"><img src="https://status.minecraftservers.org/sunset/685541.png" alt="Vortex Network Minecraft server" width="540" height="90" /></a><br />
          <button
            onClick={() => copyToClipboard(minecraftIP)}
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              background: "linear-gradient(90deg, #00f, #0ff)",
              color: "#fff",
              fontWeight: "bold",
              cursor: "pointer",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.05)";
              e.target.style.boxShadow = "0 6px 12px rgba(0,0,0,0.3)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1)";
              e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
            }}
          >
            Copy IP
          </button>
{/*          <p>
          <strong>Status:</strong>{" "}
            {minecraft.online ? (
              <span style={{ color: "limegreen" }}>Online ✅</span>
            ) : (
              <span style={{ color: "red" }}>Offline ❌</span>
            )}
          </p>
          {minecraft.online && (
            <>
              <p>
                Players: {minecraft.players}/{minecraft.max}
              </p>
              <p>Version: {minecraft.version}</p>
              <p>MOTD: {minecraft.motd}</p>
              <p>
                <strong>IP:</strong>{" "}
                <span
                  style={{
                    backgroundColor: "#222",
                    padding: "6px 10px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    color: "#0ff",
                  }}
                  onClick={() => copyToClipboard(minecraftIP)}
                  title="Click to copy"
                >
                  {minecraftIP}
                </span>
              </p>
            </>
          )}*/}
        </li>

        {/* === FIVEM === */}
        <li style={{ marginBottom: "2rem" }}>
          <h3>FiveM Server</h3>
          <p>Experience roleplay, racing, and custom jobs with the Vortex RP community.</p>
          <p>
            <strong>Status:</strong>{" "}
            {fivem.online ? (
              <span style={{ color: "limegreen" }}>Online ✅</span>
            ) : (
              <span style={{ color: "red" }}>Offline ❌</span>
            )}
          </p>
          {fivem.online && (
            <>
              <p>
                Players: {fivem.players}/{fivem.max}
              </p>
              <p>
                <strong>Join:</strong>{" "}
                <span
                  style={{
                    backgroundColor: "#222",
                    padding: "6px 10px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    color: "#0ff",
                  }}
                  onClick={() => copyToClipboard(`fivem://connect/${fivemIP}`)}
                  title="Click to copy join link"
                >
                  fivem://connect/{fivemIP}
                </span>
              </p>
            </>
          )}
        </li>

        {/* === MORE SERVERS === */}
        <li>
          <h3>And Many More coming soon...</h3>
          <p>We’re always expanding — stay tuned for more fun and creative servers!</p>
        </li>
      </ul>
    </div>
  );
}

export default Games;